import PropTypes from 'prop-types';

// The breakdown of an offer already made, one line per recipient. Renders
// nothing for an offer priced as a whole.
export default function OfferBreakdownList({ lines, className = 'sold-list' }) {
  if (!lines?.length) return null;
  return (
    <ul className={className} role="list" aria-label="Precio por destinatario">
      {lines.map((line) => (
        <li key={line.label}>
          {line.label}: {line.text}
        </li>
      ))}
    </ul>
  );
}

OfferBreakdownList.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  className: PropTypes.string,
};
